import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  getChildObjects,
  getFormRoot,
  getValueOnObjectFromStringProperty,
} from '@intellio/shared/utils';

import * as _ from 'lodash';
import type { FormlyHookFn } from './formly-hook-fn.type';

export const prepopulateAsync = (): FormlyHookFn => {
  return (field: FormlyFieldConfig) => {
    const cback = (app) => {
      const root = getFormRoot(field);
      const prepopulateObjs = getChildObjects(root, 'prepopulateAsync');
      prepopulateObjs.forEach((obj) => {
        obj.formControl.setValue(obj.props?.multiple ? [] : null);
        const fieldNameToPrepopulate = obj['prepopulateAsync'];
        let valueToPrepopulate = null;
        if (fieldNameToPrepopulate.includes(':')) {
          const params = fieldNameToPrepopulate.split(':');
          if (params[0] != '') {
            valueToPrepopulate = getValueOnObjectFromStringProperty(
              params[0],
              app
            );
          } else {
            valueToPrepopulate = app;
          }

          if (!Array.isArray(valueToPrepopulate)) {
            return;
          }

          valueToPrepopulate = valueToPrepopulate.find(
            (obj) => obj?.[params[1]]?.toString() === params[2].toString()
          );
          if (valueToPrepopulate !== undefined) {
            if (valueToPrepopulate[params[3]] !== undefined) {
              valueToPrepopulate = valueToPrepopulate[params[3]];
            }
            obj.formControl.setValue(
              obj.props?.multiple && !Array.isArray(valueToPrepopulate)
                ? [valueToPrepopulate]
                : valueToPrepopulate
            );
          }
        } else {
          valueToPrepopulate = getValueOnObjectFromStringProperty(
            fieldNameToPrepopulate,
            app
          );

          if (
            obj.props?.multiple &&
            fieldNameToPrepopulate.endsWith('Ids') &&
            (!Array.isArray(valueToPrepopulate) || valueToPrepopulate.length === 0)
          ) {
            valueToPrepopulate = getValueOnObjectFromStringProperty(
              fieldNameToPrepopulate.slice(0, -1),
              app
            );
          }

          if (valueToPrepopulate !== undefined && valueToPrepopulate !== null) {
            obj.formControl.setValue(
              obj.props?.multiple && !Array.isArray(valueToPrepopulate)
                ? [valueToPrepopulate]
                : valueToPrepopulate,
              {
                emitEvent: true,
              }
            );
          }
        }
      });
    };
    field.props.onClick = cback;
  };
};
